// extracted by mini-css-extract-plugin
export default {"horizontalFormWrapper":"styles_horizontalFormWrapper__xagY3","sizeLarge":"styles_sizeLarge__8ME20","sizeMedium":"styles_sizeMedium__hi9lV","sizeSmall":"styles_sizeSmall__jxydH"};